import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Comentarios from "../components/Comentarios";
import supabase from "../config/supabaseClient";
import estilo from "../styles/Capitulo.module.css";

import flecha from "../img/arrow.svg";
import menu from "../img/menu.svg";
import MetaDecorator from "../utils/MetaDecorator";
import CargaCapitulo from "../components/other/CargaCapitulo";

function Capitulo() {
  let navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const capitulo = useParams();
  // console.log("capitulo:", capitulo);

  const [anime, setAnime] = useState([]);
  const [informacion, setInformacion] = useState([]);
  const [servidorVideo, setServidorVideo] = useState();
  const [carga, setCarga] = useState(true);

  useEffect(() => {
    const fetchAnime = async () => {
      try {
        const { data, error } = await supabase
          .from("anime")
          .select()
          .eq("uid", capitulo.id)
          .single();

        if (error) {
          setAnime(null);
          setInformacion(null);
        }
        if (data) {
          setAnime(data);
          setInformacion(
            data.capitulos.find((e) => e.numero === Number(capitulo.cap))
          );
          setServidorVideo(
            data.capitulos.find((e) => e.numero === Number(capitulo.cap))
              .capitulo[0]
          );
          setCarga(false);
        }
      } catch (error) {
        console.log("Error");
        navigate("/" + capitulo.id);
      }
    };

    fetchAnime();
  }, [capitulo.id]);

  const servidores = informacion.capitulo;

  //Servidores de video
  const onChangeCombo = (e) => {
    const selectId = e.target.value;
    const selectServidorVideo = servidores.filter(
      (e) => e.servidor === selectId
    )[0];
    // console.log("selector", selectServidorVideo);
    setServidorVideo(selectServidorVideo);
  };

  // capitulo

  if (Number(capitulo.cap) === 0) {
    var antes = Number(capitulo.cap);
  } else if (Number(capitulo.cap) >= 0) {
    var antes = Number(capitulo.cap) - 1;
  }

  if (Number(capitulo.cap) === anime.cantidad_capitulos + 1) {
    var despues = Number(capitulo.cap);
  } else if (Number(capitulo.cap) > 0) {
    var despues = Number(capitulo.cap) + 1;
  }

  return (
    <div className={estilo.contenedor_capitulo}>
      {anime && (
        <MetaDecorator
          titulo={
            "Ver Cap " +
            informacion.numero +
            " " +
            anime.nombre +
            " en linea Gratis | yTAnimeTV"
          }
          subtitulo={anime.nombre + " | yTAnimeTV"}
          descripcion={anime.sinopsis}
          keywords={anime.nombre + " Capítulo " + informacion.numero}
          url={"https://ytanimetv.com/" + anime.uid + "/" + informacion.numero}
          canonical={
            "https://ytanimetv.com/" + anime.uid + "/" + informacion.numero
          }
        />
      )}

      {carga ? (
        <CargaCapitulo></CargaCapitulo>
      ) : (
        <>
          {anime && (
            <div className={estilo.informacion}>
              <div className={estilo.portada}>
                <img src={anime.portada} alt={anime.nombre} />
              </div>

              <div className={estilo.informacion_detalles}>
                <div className={estilo.datos}>
                  <div className={estilo.portada2}>
                    <img src={anime.portada} alt={anime.nombre} />
                  </div>

                  <h2>{anime.nombre}</h2>
                  <p>{informacion.numero}</p>
                </div>

                <div className={estilo.sinopsis}>
                  <p>{anime.sinopsis}</p>
                </div>
              </div>
            </div>
          )}
          {servidores && (
            <div className={estilo.servidores}>
              <select
                onChange={(e) => {
                  onChangeCombo(e);
                }}
              >
                {servidores.map((e, i) => (
                  <option key={i} value={e.servidor}>
                    {e.servidor}
                  </option>
                ))}
              </select>
            </div>
          )}
          {servidorVideo && (
            <div className={estilo.video}>
              {servidorVideo.link === "" ? (
                <div className={estilo.no_servidor}>
                  <p>Por favor seleccione un servidor disponible...</p>
                </div>
              ) : (
                <iframe
                  src={servidorVideo.link}
                  allowfullscreen="true"
                  frameborder="0"
                  title={anime.nombre + " capitulo " + informacion.numero}
                  width="640"
                  height="360"
                  allow="autoplay"
                ></iframe>
              )}
            </div>
          )}
          <div className={estilo.botones}>
            <button
              onClick={
                0 === antes
                  ? () => {
                      navigate("/" + anime.uid);
                    }
                  : () => {
                      navigate("/" + anime.uid + "/" + antes);
                      window.location.reload();
                    }
              }
            >
              <p className={estilo.boton_flecha}>
                <img
                  src={flecha}
                  alt="capitulo_anterior"
                  className={estilo.boton_flechitas}
                />
                {0 === antes ? "Capitulos" : "Anterior"}
              </p>
            </button>

            <button
              onClick={() => {
                navigate("/" + anime.uid);
              }}
            >
              <div className={`${estilo.boton_flecha} ${estilo.siguiente}`}>
                <img src={menu} alt="Capítulos" />
              </div>
            </button>

            <button
              onClick={
                anime.cantidad_capitulos + 1 === despues
                  ? () => {
                      navigate("/animes");
                    }
                  : () => {
                      navigate("/" + anime.uid + "/" + despues);
                      window.location.reload();
                    }
              }
            >
              <p className={`${estilo.boton_flecha} ${estilo.siguiente}`}>
                {anime.cantidad_capitulos + 1 === despues
                  ? "Más Animes"
                  : "Siguiente"}

                <img
                  src={flecha}
                  alt="capitulo_siguiente"
                  className={estilo.boton_flechitas}
                />
              </p>
            </button>
          </div>
          <div className={estilo.comentario}>
            <Comentarios></Comentarios>
          </div>
        </>
      )}
    </div>
  );
}

export default Capitulo;
